import * as Icons from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { BUSINESS_OUTCOMES } from "@/data/content";

export const BusinessOutcomes = () => {
  return (
    <section id="outcomes" data-testid="outcomes-section" className="relative py-24 sm:py-32 bg-[#F8F9FB] border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>Business Outcomes</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-tight text-slate-900">
              Measurable results across your sourcing operation.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Verified suppliers translate directly into faster decisions, lower risk and stronger manufacturing relationships.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {BUSINESS_OUTCOMES.map((o, i) => {
            const Icon = Icons[o.icon] || Icons.CheckCircle2;
            return (
              <Reveal key={o.title} delay={i * 0.05}>
                <div data-testid={`outcome-card-${i}`} className="group h-full bg-white border border-slate-200/80 rounded-2xl sm:rounded-3xl p-7 sm:p-8 transition-all duration-300 hover:shadow-[0_20px_40px_rgba(15,23,42,0.08)] hover:-translate-y-1 hover:border-blue-200">
                  <div className="flex items-center justify-between">
                    <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-blue-50 text-blue-600 border border-blue-100 transition-colors group-hover:bg-blue-600 group-hover:text-white"><Icon className="w-5 h-5" /></span>
                    <div className="text-right">
                      <div className="text-2xl sm:text-3xl font-bold font-heading tracking-tight text-slate-900">{o.metric}</div>
                      <div className="text-[11px] text-slate-400">{o.metricLabel}</div>
                    </div>
                  </div>
                  <h3 className="mt-6 text-lg font-semibold text-slate-900">{o.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{o.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BusinessOutcomes;
